import React, { Fragment, useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import { Button } from "react-bootstrap";

export default function StripeForm(props) {
    const stripe = useStripe();
    const elements = useElements();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const currentPR = props.currentPR;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${process.env.REACT_APP_BASE_URL}/${currentPR.accountId}/${currentPR.brandId}/pr/${currentPR.id}/checkout`,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error") {
            setError(error.message);
        } else {
            setError("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            {props.status != null && props.status !== 'succeeded' &&
                <Fragment>
                    <PaymentElement id="payment-element" />
                    <Button variant="swiftrev" style={{ marginTop: "25px", marginBottom: "25px" }} disabled={isLoading || !stripe || !elements} id="submit" onClick={handleSubmit}>
                        <span id="button-text">
                            Purchase
                        </span>
                    </Button>
                </Fragment>
            }
            {props.status === 'error' && <div className="text-danger" id="payment-message-stripe-error">{props.message}</div>}
            {error != null && !isLoading && <div className="text-danger" id="payment-message-card-error">{error}</div>}
            {isLoading && <div id="payment-processing">Processing payment...</div>}
        </form>
    );
}